const QOBUZ_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const LOCAL_ALBUM_HASH_RE = /^[0-9a-f]{16}$/i;

/**
 * Qobuz CDN cover from an album id. Production smart-playlist rows often have
 * album_id populated and cover_url null (playlist 33da92a9 / album t0cdwy7h4w23n).
 */
export function qobuzStaticCoverUrl(
  albumId: string | null | undefined,
  size = 600,
): string | null {
  const id = String(albumId || '').trim().replace(/^qobuz:album:/i, '');
  if (id.length < 4) return null;
  if (id.includes(':')) return null;
  if (QOBUZ_UUID_RE.test(id) || LOCAL_ALBUM_HASH_RE.test(id)) return null;
  return `https://static.qobuz.com/images/covers/${id.slice(-2)}/${id.slice(-4, -2)}/${id}_${size}.jpg`;
}
